import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Pagination, Button } from "semantic-ui-react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  UPDATE_PRODUCT_PAGE_NUMBER,
  SG_GET_PRODUCT,
  RESET_PRODUCT,
} from "constants/actions";

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let ReloadPage = searchParams.get("reload");

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(1);

  const { get_product, get_product_select } = useSelector(
    (state) => ({
      get_product: state.product.products,
      get_product_select: state.product.select_list,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch({
      type: RESET_PRODUCT,
    });
    dispatch({
      type: SG_GET_PRODUCT,
    });
  }, [dispatch]);

  console.log(get_product_select);

  useEffect(() => {
    setResults(get_product?.results);
    setPage(get_product?.pageNumber);
    setTotalPages(Math.ceil(get_product?.count / get_product?.page_size));
    if (get_product?.count % get_product?.page_size) {
      setTotalPages(Math.ceil(get_product?.count / get_product?.page_size));
    }
  }, [get_product, page, ReloadPage]);

  function handlePageChange(e, { activePage }) {
    setPage(activePage);
    dispatch({
      type: UPDATE_PRODUCT_PAGE_NUMBER,
      payload: activePage,
    });
    dispatch({
      type: SG_GET_PRODUCT,
      payload: `page=${activePage}`,
    });
  }

  function EditTemplate(templateId) {
    navigate(`/app/product/product/edit/${templateId}`);
  }

  function TemplateDetails(templateId) {
    navigate(`/app/product/product/details/${templateId}`);
  }

  function downloadJSON() {
    if (get_product_select && get_product_select.length > 0) {
      const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON.stringify(get_product_select, null, 2)
      )}`;
      const downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "product_list.json");
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    } else {
      alert("No data available to download.");
    }
  }

  return (
    <>
       {get_product_select && get_product_select.length > 0 &&  <ButtonContainer>
        <Button color="blue" onClick={downloadJSON}>
          Download Product List
        </Button>
      </ButtonContainer> }
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th>Id </th>
              <th>Name</th>
              <th>Product Group</th>
              <th>Order</th>
              <th>Version</th>
              <th>Stage</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {results &&
              results.map((product, index) => (
                <tr key={index}>
                  <td>{product.id}</td>
                  <td>{product.name}</td>
                  <td>
                    {product?.product_group_name || product?.product_group}
                  </td>
                  <td>{product.sort_order}</td>
                  <td>{product.version}</td>
                  <td>{product.product_stage}</td>
                  <td>
                    <Clickable onClick={() => EditTemplate(product?.id)}>
                      Edit{" "}
                    </Clickable>{" "}
                    |
                    <Clickable onClick={() => TemplateDetails(product.id)}>
                      Details{" "}
                    </Clickable>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>

      <Pagination
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        activePage={page}
        totalPages={totalPages ? totalPages : 0}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default List;

const TableContainer = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f4f4f4;
  }
`;

const Clickable = styled.span`
  color: blue;
  cursor: pointer;
  &:hover {
    color: red;
  }
`;

const ButtonContainer = styled.div`
  margin-bottom: 20px;
`;